export const data = {
    labels: [''],
    datasets: [
        {
            label: 'Tagesleistung (Ø pro Stunde)',
            fill: true,
            tension: 0.4,
            borderWidth: 2.5,
            borderColor: 'rgba(34, 197, 94, 1)',
            backgroundColor: 'rgba(34, 197, 94, 0.15)',
            pointRadius: 4,
            pointHoverRadius: 7,
            pointHoverBackgroundColor: 'rgba(34, 197, 94, 1)',
            pointHoverBorderColor: '#ffffff',
            pointHoverBorderWidth: 2,
            data: [0]
        }
    ]
};
